<template>
  <div class="flex-1 flex items-center justify-center px-4 py-16">
    <div class="w-full max-w-md bg-gray-800 rounded-xl border border-gray-700 px-8 py-10 shadow-xl">

      <!-- Header -->
      <div class="mb-6">
        <h1 class="text-xl font-bold text-gray-100">
          Forgot Password
        </h1>
        <p class="text-sm text-gray-500 mt-1">
          Enter your email and we'll send you a reset link.
        </p>
      </div>

      <!-- Success state -->
      <div v-if="sent" class="rounded px-4 py-4 bg-green-900/40 border border-green-700 text-green-300 text-sm mb-4">
        Check your email for a password reset link.
      </div>

      <!-- Error banner -->
      <div v-if="errorMessage" class="rounded px-4 py-3 bg-red-900/50 border border-red-700 text-red-300 text-sm mb-4">
        {{ errorMessage }}
      </div>

      <form v-if="!sent" class="space-y-4" @submit.prevent="submitForm">
        <div>
          <label class="tw-form-label" for="email">Email</label>
          <input
            id="email"
            v-model="userInfo.email"
            type="email"
            name="email"
            class="tw-form-input"
            autocomplete="email"
            placeholder="you@example.com"
            required
          >
        </div>

        <button
          type="submit"
          :disabled="loading"
          class="tw-btn w-full bg-blue-600 hover:bg-blue-500 text-white border-blue-600 font-semibold disabled:opacity-50"
        >
          <span v-if="loading">Sending…</span>
          <span v-else>Send Reset Link</span>
        </button>
      </form>

      <div class="mt-6 text-center">
        <NuxtLink to="/login" class="text-sm text-gray-500 hover:text-gray-300 underline">
          Back to Login
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userInfo: { email: '' },
      loading: false,
      sent: false,
      errorMessage: ''
    }
  },
  methods: {
    async submitForm () {
      this.loading = true
      this.errorMessage = ''
      try {
        await this.$axios.post('/recover', this.userInfo)
        this.sent = true
        setTimeout(() => this.$router.push('/login'), 3000)
      } catch (error) {
        this.errorMessage = error.response?.data?.error?.message || 'Something went wrong. Please try again.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
